import { useState, useEffect, useCallback } from "react";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function useAmenities() {

    const [amenities, setAmenities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchAmenities = useCallback(async () => {

        setLoading(true);
        setError("");

        try {

            const res = await fetch(`${API_BASE}/api/amenities`);

            if (!res.ok) {
                throw new Error("Ausstattungen konnten nicht geladen werden.");
            }

            const data = await res.json();
            console.log(data)
            setAmenities(data || []);

        } catch (e) {

            setError(e.message || "Fehler beim Laden.");

        } finally {

            setLoading(false);

        }

    }, []);


    const createAmenity = async (payload) => {

        const res = await fetch(`${API_BASE}/api/amenities`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (!res.ok) {
            throw new Error(data.error || "Ausstattung konnte nicht erstellt werden.");
        }

        await fetchAmenities();
    };


    const updateAmenity = async (id, payload) => {

        const res = await fetch(`${API_BASE}/api/amenities/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (!res.ok) {
            throw new Error(data.error || "Ausstattung konnte nicht aktualisiert werden.");
        }

        await fetchAmenities();
    };


    const deleteAmenity = async (id) => {

        const res = await fetch(`${API_BASE}/api/amenities/${id}`, {
            method: "DELETE",
        });

        const data = await res.json();

        if (!res.ok) {
            throw new Error(data.error || "Ausstattung konnte nicht gelöscht werden.");
        }

        await fetchAmenities();
    };


    useEffect(() => {
        fetchAmenities();
    }, [fetchAmenities]);


    return {
        amenities,
        loading,
        error,
        fetchAmenities,
        createAmenity,
        updateAmenity,
        deleteAmenity,
    };
}